import { render, staticRenderFns } from "./ProductSectionDocuments.vue?vue&type=template&id=d0a3293c&scoped=true"
import script from "./ProductSectionDocuments.vue?vue&type=script&lang=js"
export * from "./ProductSectionDocuments.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionDocuments.vue?vue&type=style&index=0&id=d0a3293c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a3293c",
  null
  
)

export default component.exports